import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'bootstrap-datepicker';
import './ComponentFramework/app.utility.js';
import { Page, util } from './ComponentFramework/app.js';
import ThemeToggle from './ComponentFramework/app.ThemeToggle.js';
import input from './ComponentFramework/app.input.js';
import grids from './ComponentFramework/app.grids.js';
import fileUploaders from './ComponentFramework/app.fileUploaders.js';
import pagecontent from './ComponentFramework/app.pagecontent.js';
import Autocomplete, { installAutocompletePlugin } from './ComponentFramework/app.autocomplete.js';
import sessionTimeout from './ComponentFramework/app.session-timeout.js';
import './Site/import.js';
import './WaMS/customValidators.js';
import $ from 'jquery';

// Install jQuery plugin — must happen before DOM ready so $(el).AutoComplete() works
installAutocompletePlugin();

// Expose all modules on window.app — stable public API for inline scripts in .cshtml files
// e.g. app.grids.refreshGrid(...), app.page.refreshTarget(...), app.util.openModal(...)
window.app = { util, grids, input, pagecontent, fileUploaders, ThemeToggle, Autocomplete, sessionTimeout };

// Expose jQuery globally so @section scripts can use $ without importing it
window.$ = window.jQuery = $;

$(function () {
    window.app.page = new Page(window.applicationPath);
    ThemeToggle.Init();
    input.Init();
    grids.Init();
    pagecontent.Init();
    sessionTimeout.Init();
    $(document).trigger('page-init-complete');
    document.dispatchEvent(new CustomEvent('page-init-complete'));
});
